/**
* Selector for exclusivity banner experiences
*
* This function create an selector
*
*/

export const banners = (state) => state.exclusivityBannerReducer.data.data;
